import { APP_TITLE, IS_MOBILE, LANG, SET_BREADCRUMB, THEME, THEME_CHANGE } from "../actionTypes"

const initialState = {
    appTitle: "Chat Module",
    theme: 'light',
    isMobile: false,
    lang: 'en',
    breadcrumb: []
}

const globalReducer = (state=initialState, action) => {
    switch (action.type){
        case APP_TITLE:
            return {
                ...state,
                appTitle: action.payload
            }
        case THEME:
            return {
                ...state,
                theme: action.payload
            }
        case IS_MOBILE: 
            return {
                ...state,
                isMobile: action.payload
            }
        case LANG:
            return {
                ...state,
                lang: action.payload
            }
    
        case THEME_CHANGE:
            return {
                ...state,
                theme: action.payload
            }
        case SET_BREADCRUMB:
            return {
                ...state,
                breadcrumb: action.payload
            }
        default: 
            return state;
    }
}
export default globalReducer;